// extracted by mini-css-extract-plugin
export default {"chip_box":"styles_chip_box__nLBrV","chip_background":"styles_chip_background__HURu4","chip":"styles_chip__LXyw0","logo":"styles_logo__aRoz5"};